import './choose.css';
export default function Choose() {
    return (
        <>
            <section className="services-two">
                <div
                    className="services-two_pattern"
                    data-parallax='{"y" : 80}'
                />
                <div className="auto-container">
                    <div className="sec-title-three centered">
                        {/* <div className="sec-title_title">Why Choose Us?</div> */}
                        <h2 className="sec-title_heading">Why choose Horizon for Odoo Implementation partner?</h2>
                        <div className="sec-title-three_text">
                            Selecting the right Odoo implementation partner is crucial for the success of your ERP system.  At Horizon,<br /> we bring expertise, innovation, and
                            a client-centric approach to ensure a seamless Odoo ERP <br />experience tailored to your business needs.{" "}
                        </div>
                    </div>
                    <div className="row clearfix">
                        {/* Service Block Two */}
                        <div className="service-block_two col-lg-4 col-md-6 col-sm-12">
                            <div className="service-block_two-inner">
                                <div className="service-block_two-color" />
                                <div className="service-block_two-upper">
                                    <div className="service-block_two-icon-box">
                                        <span className="service-block_two-icon fas fa-cogs" />
                                    </div>
                                    <h4 className="service-block_two-heading">
                                        <a>Expertise in Odoo ERP</a>
                                    </h4>
                                </div>
                                <div className="service-block_two-text">
                                    Our experienced team ensures high-quality Odoo implementation, customization, and integration.
                                </div>

                            </div>
                        </div>
                        {/* Service Block Two */}
                        <div className="service-block_two col-lg-4 col-md-6 col-sm-12">
                            <div className="service-block_two-inner">
                                <div className="service-block_two-color" />
                                <div className="service-block_two-upper">
                                    <div className="service-block_two-icon-box">
                                        <span className="service-block_two-icon fas fa-sliders-h" />
                                    </div>
                                    <h4 className="service-block_two-heading">
                                        <a>Tailored Solutions</a>
                                    </h4>
                                </div>
                                <div className="service-block_two-text">
                                   We customize Odoo ERP to align with your business processes for maximum efficiency.
                                </div>

                            </div>
                        </div>
                        {/* Service Block Two */}
                        <div className="service-block_two col-lg-4 col-md-6 col-sm-12">
                            <div className="service-block_two-inner">
                                <div className="service-block_two-color" />
                                <div className="service-block_two-upper">
                                    <div className="service-block_two-icon-box">
                                        <span className="service-block_two-icon fas fa-lightbulb" />
                                    </div>
                                    <h4 className="service-block_two-heading">
                                        <a>From Idea to Implementation</a>
                                    </h4>
                                </div>
                                <div className="service-block_two-text">
                                    We transform ideas into reality, from strategy to seamless execution.
                                </div>

                            </div>
                        </div>
                        {/* Service Block Two */}
                        <div className="service-block_two col-lg-4 col-md-6 col-sm-12">
                            <div className="service-block_two-inner">
                                <div className="service-block_two-color" />
                                <div className="service-block_two-upper">
                                    <div className="service-block_two-icon-box">
                                        <span className="service-block_two-icon fas fa-exchange-alt" />
                                    </div>
                                    <h4 className="service-block_two-heading">
                                        <a>Seamless Migration</a>
                                    </h4>
                                </div>
                                <div className="service-block_two-text">
                                   We ensure a hassle-free transition with secure data migration and system integration.
                                </div>

                            </div>
                        </div>
                        {/* Service Block Two */}
                        <div className="service-block_two col-lg-4 col-md-6 col-sm-12">
                            <div className="service-block_two-inner">
                                <div className="service-block_two-color" />
                                <div className="service-block_two-upper">
                                    <div className="service-block_two-icon-box">
                                        <span className="service-block_two-icon fas fa-chart-line" />
                                    </div>
                                    <h4 className="service-block_two-heading">
                                        <a>Scalable & Cost-Effective</a>
                                    </h4>
                                </div>
                                <div className="service-block_two-text">
                                    Our solutions are built for growth, ensuring a high return on investment.
                                </div>

                            </div>
                        </div>
                        {/* Service Block Two */}
                        <div className="service-block_two col-lg-4 col-md-6 col-sm-12">
                            <div className="service-block_two-inner">
                                <div className="service-block_two-color" />
                                <div className="service-block_two-upper">
                                    <div className="service-block_two-icon-box">
                                        <span className="service-block_two-icon fas fa-headset" />
                                    </div>
                                    <h4 className="service-block_two-heading">
                                        <a>Dedicated Support</a>
                                    </h4>
                                </div>
                                <div className="service-block_two-text">
                                    Our team is always available to resolve issues and provide guidance.
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}